/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { RESOURCE_TYPE_PROJECT_CONTEXT } from '@jira/router-resources__project-context/src/resourceTypeProjectContext.constants.tsx';
import type { ProjectContext } from '@jira/router-resources__project-context/src/ProjectContext.types.tsx';
import { consumeDependency } from '@jira/router-resources__utils/src/consumeDependency.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type {
	TicketTypeRest,
	TicketTypesRest,
} from '@jira/servicedesk__request-types-config-common/src/TicketTypeRest.types.tsx';

// eslint-disable-next-line jira/router/no-daisy-chaining-resources
export const playbooksListRequestTypesResource: RouteResource<TicketTypeRest[]> = createResource<
	Array<TicketTypeRest>
>({
	type: 'PLAYBOOKS-LIST-REQUEST-TYPES-RESOURCE-TYPE',
	getKey: ({ match }) => {
		const projectKey = match.params.projectKey;
		return `playbooksListRequestTypesResource-${projectKey}`;
	},
	getData: async ({ dependencies }) => {
		// oxlint-disable-next-line typescript/consistent-type-assertions
		const { projectId } = (await consumeDependency(
			dependencies,
			RESOURCE_TYPE_PROJECT_CONTEXT,
		)) as ProjectContext;

		return performGetRequest<TicketTypesRest>(getRequestTypesUrl(projectId)).then(
			(response) => response.ticketTypes,
		);
	},
	maxAge: 5 * 60 * 1000, // 5 minutes
	depends: [RESOURCE_TYPE_PROJECT_CONTEXT],
});

const getRequestTypesUrl = (projectId: number) =>
	`/rest/servicedesk/1/servicedesk/${projectId}/request-types`;
